import { FaExclamationTriangle } from 'react-icons/fa';

export default function PageNotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
      <FaExclamationTriangle className="text-6xl text-primary-400 mb-6" />
      <h1 className="text-4xl font-bold text-gray-800 mb-4">404 — Page Not Found</h1>
      <p className="text-gray-600 mb-8 text-center max-w-md">
        Oops! The page you’re looking for doesn’t exist. It might have been moved or deleted.
      </p>
      <a
        href="/"
        className="px-6 py-3 bg-secondary-400 text-white rounded-full font-medium hover:bg-secondary-500 transition"
      >
        Go Home
      </a>
    </div>
  );
}
